import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoWindowBS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 65" fill="#DEE4E8" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 0.5C5.96954 0.5 0 6.46954 0 13.8333V51.1667C0 58.5305 5.96954 64.5 13.3333 64.5H50.6667C58.0305 64.5 64 58.5305 64 51.1667V13.8333C64 6.46954 58.0305 0.5 50.6667 0.5H13.3333ZM58.6667 16.5H5.33333V13.8333C5.33333 9.41506 8.91506 5.83333 13.3333 5.83333H50.6667C55.0849 5.83333 58.6667 9.41506 58.6667 13.8333V16.5ZM5.33333 21.8333H58.6667V51.1667C58.6667 55.5849 55.0849 59.1667 50.6667 59.1667H13.3333C8.91506 59.1667 5.33333 55.5849 5.33333 51.1667V21.8333Z"
      />
    </svg>
  )
}
export const IconGeoWindowB = createIcon({
  l: IconGeoWindowBS,
  m: IconGeoWindowBS,
  s: IconGeoWindowBS,
  xs: IconGeoWindowBS,
  name: 'IconGeoWindowB',
})
